<div class="row">
  <div *ngFor="let child of data" class="col-12 col-sm-6 col-md-3 col-lg-2 mb-2">
    <div class="card card-assortment-tree h-100 card-border-top">
      <a [routerLink]="['./', child.id]" class="border-0 h-100 d-flex flex-column">
        <img
          *ngIf="child.extra.images && child.extra.images[0] as image; else noimage"
          class="card-img-top img-fluid mx-auto d-block"
          [src]="(image.s3Uri | encodeUri)
            | gungImageUrl
              :'type:list'
              :'etag:'+image.s3ETag
          "
          alt="{{ image.description }}"
        />
        <ng-template #noimage>
          <img
            class="card-img-top img-fluid w-100"
            [src]="'images/no-image.jpg'
              | gungImageUrl
                :'type:list'
            "
            alt="NO IMAGE"
            class="img-fluid mx-auto d-block"
          />
        </ng-template>
        <div class="card-body d-flex">
          <div class="card-title align-self-end w-100">
            <a
              [routerLinkActive]="'active-assortment'"
              [routerLink]="['./', child.id]"
              class="d-flex align-items-center justify-content-between text-break border-0"
            >
              <span>{{ child.extra?.i18n && child.extra.i18n[currentLang] && child.extra?.i18n[currentLang]?.assortmentName ? child.extra.i18n[currentLang].assortmentName : child.name }}</span>
              <i class="fa fa-angle-right align-self-end" aria-hidden="true" style="font-size: x-large"></i>
            </a>
          </div>
          <p class="card-text"></p>
        </div>
      </a>
    </div>
  </div>
</div>
